import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { AppRoutes } from '@constants/app.route';
import { musicResolver } from './resolvers/music.resolver';
import { i18nInitGuard } from './guards/i18n-init-guard';
import { authRedirectGuard } from './guards/already-auth.guard';
import { datalistResolver } from './resolvers/data.resolver';


export const routes: Routes = [
	{
		path: AppRoutes.AUTH,
		loadComponent: () => import('./authentication/authentication.page').then(m => m.AuthenticationPage),
		canActivate: [authRedirectGuard]
	},
	{
		path: '',
		loadComponent: () => import('./shell/shell.page').then(m => m.ShellPage),
		canActivate: [i18nInitGuard],
		canActivateChild: [authGuard],
		children: [
			{
				path: AppRoutes.DATASET,
				resolve: { datalistLoaded: datalistResolver },
				runGuardsAndResolvers: 'always',
				loadComponent: () => import('./dataset/dataset.page').then((m) => m.DatasetPage),
				children: [
					{
						path: AppRoutes.DATASETEDIT,
						resolve: { musicLoaded: musicResolver },
						runGuardsAndResolvers: 'always',
						loadComponent: () => import('./dataset/edit/edit.page').then( m => m.EditPage)
					},
					{
						path: AppRoutes.DATASETADD,
						loadComponent: () => import('./dataset/add/add.page').then( m => m.AddPage)
					},
					{
						path: AppRoutes.DATASETVIEW,
						loadComponent: () => import('./dataset/view/view.page').then( m => m.ViewPage)
					},
					{ path: '', pathMatch: 'full', redirectTo: AppRoutes.DATASETEDIT },
				]
			},
			{
				path: AppRoutes.OTHER,
    			loadComponent: () => import('./other/other.page').then( m => m.OtherPage)
			},
			{ path: '', pathMatch: 'full', redirectTo: AppRoutes.DATASET }
		]
	},
	{ path: '**', redirectTo: AppRoutes.DATASET }
];
